export const ArrNavbar = [
  { text: "Home" },
  { text: "About" },
  { text: "FAQs" },
  { text: "Contact" },
  { text: "Download" },
];
